import { Component } from '@angular/core';

@Component({
  template: '<div class="col-md-12 text-center" style="padding-top:200px; padding-bottom:250px;"><p style="font-size: 60px;">Упс..</p><h2 style="font-size: 40px;">Страница не работает. Ведутся работы. :(</h2><a class="btn btn-default" routerLink="/">Главная страница</a></div>'
})
export class PageNotWorkingComponent { }



// WEBPACK FOOTER //
// /app/SPA/src/app/page-not-working.component.ts